import { render } from "./ValidationObserver.vue?vue&type=template&id=2a45f9f0"
import script from "./ValidationObserver.vue?vue&type=script&lang=js"
export * from "./ValidationObserver.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/ValidationObserver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a45f9f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a45f9f0', __exports__)) {
    api.reload('2a45f9f0', __exports__)
  }
  
  module.hot.accept("./ValidationObserver.vue?vue&type=template&id=2a45f9f0", () => {
    api.rerender('2a45f9f0', render)
  })

}


export default __exports__